// removed by extract-text-webpack-plugin
module.exports = {"nf-new-org-form":"nf-new-org-form","nf-button":"nf-button","nf-org-message":"nf-org-message","nf-org-status":"nf-org-status"};


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/NewOrganizationForm/NewOrganization.scss
// module id = 5542
// module chunks = 1